<template>
  <ToggleSection
    label="Grid Preparation Details (Room Temperature EM)"
    :collapsed="!dv.isEditing"
  >
    <FieldGrid
      class="form-fields"
      :fields="[
        ['rt_tem_grid_model', 'rt_tem_support_film'],
        ['rt_tem_section_thickness', 'immunogold'],
      ]"
      :dv="dv"
      :validation-errors="validationErrors"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'GridPreparationRT',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
  },
}
</script>
